import React from 'react';
import { store } from '../../store'
import TilbodNavigation from '../tilbod-navigation'
import Tab from 'react-bootstrap/Tab'
import TabContainer from 'react-bootstrap/TabContainer'
import TabContent from 'react-bootstrap/TabContent'
import Nav from 'react-bootstrap/Nav'
import { customerNameById, formatKennitala, formatKennitalaAsDate, getPersonTypeByAge, idStepValid } from '../../utils'
import { setInfoKey, setInfoKeyMulti } from '../../api/information-collection/actions'
import { setKey } from '../../api/insurance-takers/actions'
import { SvgArrowIcon, SvgCheckIcon } from '../svg';

import connectWithStore from '../../utils/store'

import IdCollection from '../id-collection';
import TaxInfoCollection from '../tax-info-collection';
import ContactInfoCollection from '../contact-info-collection';

import Accordion from 'react-bootstrap/Accordion'
import Card from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'
import { getCountries } from '../../api/countries/actions';
import { fetchIdentification } from '../../api/id/actions';
import IdSelection from '../id-selection';
import { Spinner } from '../../utils';


class TilbodStepId extends React.Component {

    constructor(props) {
        super(props)
    }

    componentDidMount() {
        this.props.dispatch(getCountries());
        Object.keys(this.props.offers.offerQueryParameters).map((customerId, idx) =>
            Object.keys(this.getInsuranceTakers(customerId)).map((insuranceTaker) =>
                this.props.dispatch(fetchIdentification(insuranceTaker)))
        )
        window.scrollTo(0, 0);
    }


    getInitialValues(customerId) {
        return this.props.infoCollection.data[customerId]
    }

    getInitialInsuranceTakerValues(insuranceTaker) {
        return this.props.insuranceTakers.insuranceTakers[insuranceTaker]
    }

    UNSAFE_componentWillMount() {
        Object.keys(this.props.offers.offerQueryParameters).map((customerId, idx) => {
            this.props.dispatch(setInfoKey({ key: undefined, value: undefined }, customerId))
        })

        Object.keys(this.props.offers.offerQueryParameters).map((customerId, idx) => {
            Object.keys(this.getInsuranceTakers(customerId)).map((insuranceTaker) =>
                this.props.dispatch(setKey({ key: undefined, value: undefined }, insuranceTaker))
            )
        }
        )
    }

    onNavLinkClick(e) {
        var tab = $(e.target).parents('.nav-item').prev('.nav-item');

        $('.step .nav-item').removeClass('no-border');
        tab.addClass('no-border');
    }

    onButtonClick(e) {
        $('.step .card-header').removeClass('body-show');
        if (!$(e.target).parent().siblings('.collapse').hasClass('show')) {
            $(e.target).parent().addClass('body-show');
        }
    }

    getInsuranceTakers(customerId) {
        let insuranceTakers = []
        Object.keys(this.getInitialValues(customerId)).map((k) => {
            if (k.includes('insuranceTaker') && !k.includes('Gender') && !k.includes('Name') && !k.includes('Birthdate') && !k.includes('Address') && !k.includes('Postcode') && !k.includes('City')) {
                if (insuranceTakers[this.getInitialValues(customerId)[k]]) {

                    insuranceTakers[this.getInitialValues(customerId)[k]].push(k)
                } else {
                    insuranceTakers[this.getInitialValues(customerId)[k]] = [k]
                }
            }
        })
        return insuranceTakers;
    }

    checkForRISInsurance(customerId) {
        let isRis = false;
        let active = false;
        let len = Object.keys(this.props.offers.offerQueryParameters[customerId]).length;
        if (len == 1) {
            Object.entries(this.props.offers.offerQueryParameters[customerId]).map((arr) => {
                isRis = (arr[0] == "RIS");
                active = arr[1];
            })
        }
        return isRis && active;
    }


    render() {
        const {
            customers,
            identification,
        } = this.props

        return (
            <>
                <div className="row justify-content-center xs-pt-10">
                    <div className="col-12 col-sm-10 col-md-8">
                        <div className="row justify-content-center xs-pt-10 step">
                            <Tab.Container id="base-info-collection-tabs" defaultActiveKey={Object.keys(this.props.offers.offerQueryParameters)[0]} >
                                <div className="tabs-container">
                                    <Nav variant="tabs" className="tabs w-100">
                                        {Object.keys(this.props.offers.offerQueryParameters).map((customerId, idx) =>
                                            <Nav.Item key={customerId} className="check">
                                                <Nav.Link eventKey={customerId} onClick={this.onNavLinkClick.bind(this)}>
                                                    {customerNameById(customerId, customers)}<span>({formatKennitala(customerId)})</span>
                                                </Nav.Link>
                                                {idStepValid(customerId, this.props) &&
                                                    <span className="check-icon small blue"><SvgCheckIcon /></span>
                                                }
                                            </Nav.Item>
                                        )}
                                    </Nav>
                                </div>
                                <Tab.Content className="w-100">

                                    {Object.keys(this.props.offers.offerQueryParameters).map((customerId, idx) =>
                                        <React.Fragment key={customerId}>
                                            <Tab.Pane eventKey={customerId}>
                                                <p className="content-title">Gagnasöfnun {getPersonTypeByAge(customerId) === "child" && <>(tryggingartaka)</>}</p>
                                                <Accordion defaultActiveKey={"0"}>
                                                    {Object.keys(this.getInsuranceTakers(customerId)).map((insuranceTaker) =>
                                                        <React.Fragment key={`${customerId}-${insuranceTaker}`}>
                                                            {this.checkForRISInsurance(customerId) ? null :
                                                                <>
                                                                    {identification && identification.customers[insuranceTaker] && !identification.customers[insuranceTaker].isFetching ?
                                                                        <>
                                                                            {(identification && identification.customers[insuranceTaker].done && identification.customers[insuranceTaker].Customer && identification.customers[insuranceTaker] && !identification.customers[insuranceTaker].isFetching && identification.customers[insuranceTaker].done && identification.customers[insuranceTaker].Customer && identification.customers[insuranceTaker].Customer.Identification && identification.customers[insuranceTaker].Customer.Identification.IdentificationCard) ?
                                                                                <IdSelection
                                                                                    formKey={`${customerId}-${insuranceTaker}`}
                                                                                    dispatch={this.props.dispatch}
                                                                                    customerId={insuranceTaker}
                                                                                    identification={this.props.identification}
                                                                                    insuranceTakers={this.props.insuranceTakers}
                                                                                    match={this.props.match}
                                                                                    store={this.props.store}
                                                                                    signers={[insuranceTaker]}
                                                                                    infoCollection={this.props.infoCollection}
                                                                                    offerQueryParameters={this.props.offerQueryParameters}
                                                                                    peopleByKennitala={this.props.customers.peopleByKennitala}
                                                                                    requirePhoto={false}
                                                                                    enableSubmitLater={true}
                                                                                />

                                                                                :
                                                                                <Card>
                                                                                    <Card.Header className="body-show">
                                                                                        <Accordion.Toggle as={Button} variant="link" eventKey="0" onClick={(e) => this.onButtonClick(customerId, 0, e)} className="toggle-button">
                                                                                            {this.getInitialInsuranceTakerValues(insuranceTaker).confirm ? (<span className="check"><span className="check check-icon big green">
                                                                                                <SvgCheckIcon />
                                                                                            </span></span>) : (<span></span>)}
                                                                                            Skilríki: {customerNameById(insuranceTaker, customers)} ({insuranceTaker})
                                                                                            <span className="arrow-toggle-button">
                                                                                                <SvgArrowIcon />
                                                                                            </span>
                                                                                        </Accordion.Toggle>
                                                                                    </Card.Header>
                                                                                    <Accordion.Collapse eventKey="0">
                                                                                        <Card.Body>
                                                                                            <IdCollection customerId={customerId} insuranceTaker={insuranceTaker} countries={this.props.countries} dispatch={this.props.dispatch} infoCollection={this.getInitialValues(customerId)} initialValues={this.getInitialInsuranceTakerValues(insuranceTaker)} hasVID={this.props.offers.offerQueryParameters[customerId].hasOwnProperty("VID")} />
                                                                                        </Card.Body>
                                                                                    </Accordion.Collapse>
                                                                                </Card>
                                                                            }
                                                                        </>
                                                                        :
                                                                        <div className="text-center mt-5 mb-5"><Spinner /></div>
                                                                    }
                                                                    <Card>
                                                                        <Card.Header className="body-show">
                                                                            <Accordion.Toggle as={Button} variant="link" eventKey="2" onClick={(e) => this.onButtonClick(customerId, 0, e)} className="toggle-button">
                                                                                {this.getInitialInsuranceTakerValues(insuranceTaker).taxInfoConfirm ? (<span className="check"><span className="check check-icon big green">
                                                                                    <SvgCheckIcon />
                                                                                </span></span>) : (<span></span>)}
                                                                                Skattskylda og varnir gegn peningaþvætti
                                                                                <span className="arrow-toggle-button">
                                                                                    <SvgArrowIcon />
                                                                                </span>
                                                                            </Accordion.Toggle>
                                                                        </Card.Header>
                                                                        <Accordion.Collapse eventKey="2">
                                                                            <Card.Body>
                                                                                <TaxInfoCollection 
                                                                                    customerId={customerId}
                                                                                    insuranceTaker={insuranceTaker}
                                                                                    nationalRegistry={this.props.insuranceTakers.nationalRegistry[customerId]}
                                                                                    jobs={this.props.jobs}
                                                                                    dispatch={this.props.dispatch}
                                                                                    infoCollection={this.getInitialValues(customerId)}
                                                                                    offers={this.props.offers}
                                                                                    initialValues={this.getInitialInsuranceTakerValues(insuranceTaker)}
                                                                                    isFORorFORE = {this.props.offers.offerQueryParameters[customerId].hasOwnProperty("FOR") || this.props.offers.offerQueryParameters[customerId].hasOwnProperty("FORE")}
                                                                                    hasVID={this.props.offers.offerQueryParameters[customerId].hasOwnProperty("VID")}
                                                                                    onlyRISLEB={Object.keys(this.props.offers.offerQueryParameters[customerId]).filter((key) => this.props.offers.offerQueryParameters[customerId][key] === true).length === 1 && this.props.offers.offerQueryParameters[customerId].hasOwnProperty("RISLEB")}
                                                                                />
                                                                            </Card.Body>
                                                                        </Accordion.Collapse>
                                                                    </Card>
                                                                </>
                                                            }
                                                            <Card>
                                                                <Card.Header className="body-show">
                                                                    <Accordion.Toggle as={Button} variant="link" eventKey="1" onClick={(e) => this.onButtonClick(customerId, 0, e)} className="toggle-button">
                                                                        {this.getInitialInsuranceTakerValues(insuranceTaker).contactInfoConfirm ? (<span className="check"><span className="check check-icon big green">
                                                                            <SvgCheckIcon />
                                                                        </span></span>) : (<span></span>)}
                                                                        Tengslaupplýsingar: {customerNameById(insuranceTaker, customers)} ({insuranceTaker})
                                                                        <span className="arrow-toggle-button">
                                                                            <SvgArrowIcon />
                                                                        </span>
                                                                    </Accordion.Toggle>
                                                                </Card.Header>
                                                                <Accordion.Collapse eventKey="1">
                                                                    <Card.Body>
                                                                        <ContactInfoCollection dispatch={this.props.dispatch} initialValues={this.getInitialInsuranceTakerValues(insuranceTaker)} customerId={insuranceTaker} />
                                                                    </Card.Body>
                                                                </Accordion.Collapse>
                                                            </Card>
                                                        </React.Fragment>
                                                    )}
                                                </Accordion >
                                            </Tab.Pane>
                                        </React.Fragment>
                                    )}

                                </Tab.Content>
                            </Tab.Container>

                        </div>
                    </div>
                </div>



                <TilbodNavigation />
            </>
        )
    }
}

TilbodStepId.defaultProps = {
}

function mapStateToProps(state) {

    var f = {
        customers: {},
        offers: {},
        gui: {},
        nationalRegistry: {},
        infoCollection: {},
        offerQueryParameters: {},
        virtualCard: {},
        insuranceTakers: {},
        countries: {},
        jobs: {},
        identification: {},
    }
    f.customers = (state.customers === undefined) ? {} : state.customers
    f.offers = (state.offers === undefined) ? {} : state.offers
    f.gui = (state.gui === undefined) ? {} : state.gui
    f.nationalRegistry = (state.nationalRegistry === undefined) ? {} : state.nationalRegistry
    f.infoCollection = (state.infoCollection === undefined) ? {} : state.infoCollection
    f.offerQueryParameters = (state.offerQueryParameters === undefined) ? {} : state.offerQueryParameters
    f.virtualCard = (state.virtualCard === undefined) ? {} : state.virtualCard
    f.insuranceTakers = (state.insuranceTakers === undefined) ? {} : state.insuranceTakers
    f.countries = (state.countries === undefined) ? {} : state.countries
    f.jobs = (state.jobs === undefined) ? {} : state.jobs
    f.identification = (state.identification === undefined) ? {} : state.identification

    return f;
}

export default connectWithStore(store, TilbodStepId, mapStateToProps);
